import React from 'react';
import { Link } from 'react-router-dom';
import './Terms.css';
import Footer from '../Footer/FooterWrapper';
import { useLanguage } from '../../i18n/LanguageContext';

const Terms = () => {
  const { t, tRaw } = useLanguage();
  const sections = tRaw('legal.termsSections') || [];

  return (
    <>
      <div className="terms-container">
        <h2>{t('legal.termsTitle')}</h2>

        {sections.map((section) => (
          <div className="terms-item" key={section.title}>
            <h3>{section.title}</h3>
            {section.body.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
        ))}

        <div className="cta-link">
          <Link to="/">
            <button className="cta-button">{t('legal.backHome')}</button>
          </Link>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Terms; 
